import { render, staticRenderFns } from "./ClientSearchOrCreate.vue?vue&type=template&id=58122534"
import script from "./ClientSearchOrCreate.vue?vue&type=script&lang=js"
export * from "./ClientSearchOrCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports